import { CSSProperties, FC, PropsWithChildren, useEffect } from "react";
import styles from './ModalStyles.module.css';
import { clsx } from "clsx";
import { createPortal } from "react-dom";

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  backdropClassName?: string;
  contentClassName?: string;
  contentStyle?: CSSProperties;
}

type ModalType = FC<PropsWithChildren<ModalProps>>;

export const Modal: ModalType = (props) => {
  const { children, isOpen = false, onClose, backdropClassName = "", contentClassName = "", contentStyle } = props;

  const backdropClasses = clsx(styles.modal_backdrop, backdropClassName);
  const contentClasses = clsx(styles.modal_content, styles.animate_pop, contentClassName);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
    }

    return () => {
      document.documentElement.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className={backdropClasses} onClick={onClose}>
      <div
        onClick={(e) => e.stopPropagation()}
        className={contentClasses}
        tabIndex={-1}
        style={contentStyle}
      >
        {children}
      </div>
    </div>,
    document.body,
  );
};